import AuthProvider from "./auth-provider";

export default class VkAuthProvider extends AuthProvider {
  constructor(vkApiId) {
    super('vk');
    this.vkApiId = vkApiId;
  }

  loadScript() {
    let script = document.createElement('script');
    script.src = 'https://vk.com/js/api/openapi.js?168'
    document.head.append(script);

    script.onload = () => {
      VK.init({apiId: this.vkApiId});
      VK.Widgets.Auth('vk-auth', {
        'onAuth': (data) => {
          const urlPattern = /^(https?:\/\/)/i;
          let avatarUrl = data.photo_rec;
          if (!!avatarUrl) {
            avatarUrl = avatarUrl.replaceAll('&amp;', '&');
          }
          // ВК возвращает дефолтную картинку без домена vk.com
          if (!urlPattern.test(avatarUrl)) {
            avatarUrl = 'https://vk.com/' + avatarUrl;
          }
          this.trigger({
            type: 'providerAuthorized',
            data: {
              provider: this.name,
              userData: {
                userID: `${this.name}${data.uid}`,
                name: `${data.first_name} ${data.last_name}`,
                avatarUrl: avatarUrl
              }
            }
          });
        }
      });
      this.trigger('scriptLoaded');
    };

    script.onerror = () => {
      console.warn("VK provider: the script didn't load.");
      this.trigger('scriptLoaded');
    };
  }
}
